export const HOME = { emergentLink: "emergent-link" };

export const IDS = {
  app: "dispatch-app",
  login: { page: "login-page", email: "login-email", password: "login-password", submit: "login-submit", error: "login-error", demo: "login-demo" },
  layout: { grid: "dashboard-grid", pane: (id) => `pane-${id}`, handle: (id) => `pane-handle-${id}`, close: (id) => `pane-close-${id}`, reset: "layout-reset", lock: "layout-lock", menu: "panes-menu", menuItem: (id) => `panes-menu-${id}` },
  talkgroups: {
    section: "talkgroups-section",
    card: (id) => `talkgroup-card-${id}`,
    ptt: (id) => `talkgroup-ptt-${id}`,
    delete: (id) => `talkgroup-delete-${id}`,
    member: (tg, c) => `talkgroup-member-${tg}-${c}`,
    groupMode: "roster-group-mode",
    check: (id) => `roster-group-check-${id}`,
    create: "talkgroup-create-btn",
    dialog: "talkgroup-dialog",
    name: "talkgroup-name",
    submit: "talkgroup-submit",
    avatar: (id) => `roster-avatar-${id}`,
  },
  header: {
    root: "dispatch-header",
    clock: "system-clock",
    connectionStatus: "connection-status",
    simToggle: "simulator-toggle",
    masterMute: "master-mute",
    settings: "settings-btn",
    userMenu: "user-menu",
    logout: "logout-btn",
  },
  users: {
    tab: "settings-tab-users",
    list: "users-list",
    row: (id) => `user-row-${id}`,
    email: "new-user-email",
    name: "new-user-name",
    password: "new-user-password",
    role: "new-user-role",
    create: "new-user-create",
    delete: (id) => `user-delete-${id}`,
    roleToggle: (id) => `user-role-${id}`,
  },
  zello: {
    tab: "settings-tab-zello",
    status: "zello-status",
    connect: "zello-connect",
    disconnect: "zello-disconnect",
    autoConnect: "settings-zello-auto-connect",
    headerStatus: "zello-header-status",
  },
  settings: {
    dialog: "settings-dialog",
    provider: "settings-provider",
    zelloNetwork: "settings-zello-network",
    zelloUsername: "settings-zello-username",
    zelloPassword: "settings-zello-password",
    apiEndpoint: "settings-api-endpoint",
    authToken: "settings-auth-token",
    dispatcherName: "settings-dispatcher-name",
    mapProvider: "settings-map-provider",
    googleKey: "settings-google-key",
    unitMovement: "settings-unit-movement",
    sosSimRate: "settings-sos-sim-rate",
    sosAudible: "settings-sos-audible",
    micDevice: "settings-mic-device",
    speakerDevice: "settings-speaker-device",
    refreshDevices: "settings-refresh-devices",
    timezone: "settings-timezone",
    retention: "settings-retention",
    theme: "settings-theme",
    transcription: "settings-transcription",
    showTrails: "settings-show-trails",
    currentPassword: "settings-current-password",
    newPassword: "settings-new-password",
    changePassword: "settings-change-password",
    save: "settings-save",
  },
  broadcast: {
    toggle: "select-mode-toggle",
    bar: "broadcast-bar",
    ptt: "broadcast-ptt",
    count: "broadcast-count",
    clear: "broadcast-clear",
    selectAll: "broadcast-select-all",
    channelCheck: (id) => `broadcast-check-channel-${id}`,
    contactCheck: (id) => `broadcast-check-contact-${id}`,
  },
  patches: {
    root: "patches-panel",
    button: "patch-btn",
    add: "add-patch-btn",
    dialog: "add-patch-dialog",
    name: "add-patch-name",
    channelOption: (id) => `patch-channel-option-${id}`,
    submit: "add-patch-submit",
    item: (id) => `patch-${id}`,
    toggle: (id) => `patch-toggle-${id}`,
    delete: (id) => `patch-delete-${id}`,
    badge: (id) => `channel-patch-badge-${id}`,
  },
  roster: {
    root: "roster-sidebar",
    item: (id) => `roster-item-${id}`,
    ptt: (id) => `roster-ptt-${id}`,
    online: (id) => `roster-online-${id}`,
    addUser: "add-user-btn",
    addUserDialog: "add-user-dialog",
    addUserSubmit: "add-user-submit",
    addUserName: "add-user-name",
    addUserRole: "add-user-role",
  },
  channels: {
    grid: "channels-grid",
    card: (id) => `channel-card-${id}`,
    ptt: (id) => `channel-ptt-${id}`,
    addChannel: "add-channel-btn",
    addChannelDialog: "add-channel-dialog",
    addChannelName: "add-channel-name",
    addChannelSubmit: "add-channel-submit",
    delete: (id) => `channel-delete-${id}`,
    edit: (id) => `channel-edit-${id}`,
    tone: (id) => `channel-tone-${id}`,
    editDialog: "channel-edit-dialog",
    editName: "channel-edit-name",
    editDesc: "channel-edit-desc",
    editColor: (c) => `channel-edit-color-${c.replace("#", "")}`,
    editZello: "channel-edit-zello",
    editPriority: "channel-edit-priority",
    editTone: "channel-edit-tone",
    editTonePreview: "channel-edit-tone-preview",
    editToneRepeats: "channel-edit-tone-repeats",
    editToneVolume: "channel-edit-tone-volume",
    editSave: "channel-edit-save",
  },
  activity: {
    root: "activity-log",
    item: (id) => `activity-item-${id}`,
  },
  map: { root: "mini-map", marker: (id) => `map-marker-${id}`, pttMarker: (id) => `map-ptt-${id}` },
  alerts: {
    root: "alerts-panel",
    item: (id) => `alert-${id}`,
    ack: (id) => `alert-ack-${id}`,
    trigger: "trigger-sos-btn",
  },
  logger: {
    root: "audio-logger",
    row: (id) => `logger-row-${id}`,
    play: (id) => `logger-play-${id}`,
    filter: "logger-filter",
  },
};
